import React, { useMemo } from 'react';
import {
  FormDialog,
  IMAGE_FILE_ACCEPT,
  RhfFileInput,
  toast,
} from '@core/components';
import type { AlbSubtype } from '../../api/albSubtype';
import { updateAlbSubtype } from '../../api/albSubtype';
import { getImageThumbnailUrl } from '../utils/image';

interface AlbSubtypeDialogProps {
  open: boolean;
  onClose: () => void;
  subtype: AlbSubtype | null;
  onSuccess?: () => void;
}

type AlbSubtypeFormValues = {
  image: File | null;
};

const AlbSubtypeDialog: React.FC<AlbSubtypeDialogProps> = ({
  open,
  onClose,
  subtype,
  onSuccess,
}) => {
  const defaultValues = useMemo<AlbSubtypeFormValues>(
    () => ({ image: null }),
    []
  );

  const onSubmit = async (data: AlbSubtypeFormValues) => {
    if (!subtype) {
      return;
    }
    try {
      await updateAlbSubtype(subtype.id, data.image ?? undefined);
      toast.success('Image updated');
      onSuccess?.();
    } catch (error) {
      toast.apiError('Failed to save image.', error);
      throw error;
    }
  };

  return (
    <FormDialog<AlbSubtypeFormValues>
      open={open}
      onClose={onClose}
      title={subtype ? `Edit ${subtype.name}` : 'Edit subtype'}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      submitText="Update"
      maxWidth="xs"
    >
      <RhfFileInput<AlbSubtypeFormValues>
        name="image"
        label="Image"
        accept={IMAGE_FILE_ACCEPT}
        initialPreviewSrc={getImageThumbnailUrl(subtype)}
      />
    </FormDialog>
  );
};

export default AlbSubtypeDialog;
